import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../config/api';

export default function CameraParentAccessSettings({ settings, onSaved }) {
  const [draft, setDraft] = useState(settings), [busy, setBusy] = useState(false), [message, setMessage] = useState(''), [error, setError] = useState('');
  useEffect(() => { setDraft(settings); }, [settings.updatedAt]);
  const update = (index, key, value) => setDraft(current => ({ ...current, days: current.days.map((row, i) => i === index ? { ...row, [key]: value } : row) }));
  const save = async event => {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      const response = await fetch(`${API_ENDPOINTS.BASE_URL}/api/classroom-cameras/parent-access-settings`, { method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(draft) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Unable to save viewing hours.');
      setDraft(data.settings); setMessage('Parent viewing hours saved.'); onSaved?.();
    } catch (error) { setError(error.message); }
    finally { setBusy(false); }
  };
  return <section className="camera-parent-access" aria-labelledby="parent-viewing-hours">
    <h2 id="parent-viewing-hours">Parent Viewing Hours</h2>
    <p>Africa/Lagos</p>
    <form onSubmit={save}>
      <fieldset disabled={busy}>
        <div className="camera-hours-heading" aria-hidden="true"><span>Day</span><span>Open</span><span>From</span><span>Until</span></div>
        {draft.days.map((row, index) => <div className="camera-hours-row" key={row.day}>
          <span>{row.day}</span>
          <input type="checkbox" aria-label={`Allow parent viewing on ${row.day}`} checked={row.enabled} onChange={event => update(index, 'enabled', event.target.checked)}/>
          <label className="camera-time-label"><span>From</span><input type="time" aria-label={`${row.day} opening time`} value={row.start} required disabled={!row.enabled} onChange={event => update(index, 'start', event.target.value)}/></label>
          <label className="camera-time-label"><span>Until</span><input type="time" aria-label={`${row.day} closing time`} value={row.end} required disabled={!row.enabled} onChange={event => update(index, 'end', event.target.value)}/></label>
        </div>)}
      </fieldset>
      <button disabled={busy} type="submit">{busy ? 'Saving...' : 'Save viewing hours'}</button>
      {error && <p className="camera-notice" role="alert">{error}</p>}
      {message && <p role="status">{message}</p>}
    </form>
  </section>;
}
